// Auto-generated by scripts/generate-build-info.mjs. Do not edit by hand.
export const BUILD_COMMIT = "78d44d5ee5f41cf26c5105ebb595d9d192595bb7";
export const BUILD_DATE = "2026-04-19T22:10:54Z";
